<template>
  <div></div>
</template>

<script>
  import Painterro from "painterro";

  export default {
    name: "SPainter",
    props: {
      backgroundImage: {
        default: null,
      },
      language: {
        type: String,
        default: "de",
      },
    },
    data() {
      return {
        showCount: 0,
        editor: null,
        firstShow: true,
      };
    },
    created() {
      var self = this;
      this.editor = Painterro(this.config(self));
    },
    mounted() {
      this.editor.saveHandler = function (image) {
        console.log(image);
      };
    },
    methods: {
      show() {
        if (this.backgroundImage && this.firstShow)
          this.editor.show(this.backgroundImage);
        else this.editor.show(this.backgroundImage);

        this.firstShow = false;
      },
      config(instance) {
        const standardSizes = [1, 2, 4, 8, 12, 16, 64];

        return {
          colorScheme: {
            controlContent: "#fff", // make panels light-yellow
            control: "#66b7e2", // change controls color
            inputShadow: "none",
            inputBorderColor: "#000",
            activeControlContent: "#000",
            main: "#fff",
          },
          activeColor: "#000",
          activeFillColor: "#fff",
          activeFillColorAlpha: 1.0,
          defaultLineWidth: 4,
          language: this.language,
          how_to_paste_actions: "replace_all",
          hiddenTools: [
            "resize",
            "crop",
            "rotate",
            "resize",
            "open",
            "close",
            "zoomin",
            "zoomout",
            "settings",
            "pixelize",
            "select",
            "eraser",
          ],
          defaultTool: ["brush"],
          defaultPrimitiveShadowOn: false,
          defaultEraserWidth: 4,
          availableLineWidths: standardSizes,
          availableEraserWidths: standardSizes,
          availableFontSizes: standardSizes,
          buttonSizePx: 35,
          toolbarHeightPx: 50,
          saveHandler: function (image, done) {
            instance.$emit("image-saved", image.asDataURL());
            done();
            instance.editor.hide();
          },
        };
      },
    },
  };
</script>

<style lang="scss">
  .ptro-tool-ctl-name {
    background-color: #333;
  }
</style>
